import React, { useEffect, useState } from "react"
import {
  Row, Col, Card, CardBody, CardTitle,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import "./datatables.scss"
// import "./lb.css"
import "./Inventory/Inventory.css"
import classnames from "classnames"
import LevelUpNotification from "./LevelUpNotification/Levelupnotification"

const Alldata = JSON.parse(localStorage.getItem("dataJ"))

const Leaderboard = () => {
  const obj = JSON.parse(localStorage.getItem("authUser"))
  const [ActiveTab, setActiveTab]             = useState("Individual")
  const [activeTabContent, setactiveTabContent] = useState("1")
  const loader = document.querySelector(".loader")
  const [IndividualScore, setIndividualScore] = useState([])
  const [TeamScore, setTeamScore]             = useState([])

  // ── Notification state ──────────────────────────────────────
  const [showNotif, setShowNotif]   = useState(false)   // triggers after data loads
  const [myScoreObj, setMyScoreObj] = useState(null)    // current user's score row
  const [notifDone, setNotifDone]   = useState(false)   // show only once per session

  const toggle1 = tab => { if (ActiveTab !== tab) setActiveTab(tab) }

  useEffect(() => {
    loader.classList.add("loader--hide")
    let scorr = []

    fetch(process.env.REACT_APP_ADMIN + "/getscores")
      .then(r => r.json())
      .then(async data => {
        await data.map((el, index) => {
          let totalScore = el.scores.reduce((acc, sc) => acc + sc.score, 0)
          let totalTime  = el.scores.reduce((acc, sc) => acc + sc.time,  0) / 1000
          let item = {
            key: index, id: el.id, name: el.name,
            createdAt: el.createdAt, total: totalScore, rank: 0, time: totalTime,
          }
          Alldata.helper.leaderboard.active.map(active => {
            const match = el.scores.find(s => s.gname === active)
            item[active] = match ? match.score : 0
          })
          scorr.push(item)
        })

        scorr.sort((a, b) => b.total !== a.total ? b.total - a.total : a.time - b.time)

        let currentRank = 1
        scorr[0].rank = currentRank
        for (let i = 1; i < scorr.length; i++) {
          if (scorr[i-1].total === scorr[i].total && scorr[i-1].time === scorr[i].time) {
            scorr[i].rank = scorr[i-1].rank
          } else {
            scorr[i].rank = ++currentRank
          }
        }

        const myEmail = obj?.EmailAddress || obj?.Email || obj?.email || ""
        const myName  = obj?.Firstname
          ? `${obj.Firstname}${obj.Lastname ? " " + obj.Lastname : ""}`.trim()
          : obj?.name || obj?.Name || myEmail

        const myScore = scorr.find(el =>
          el.id === myEmail ||
          el.id === obj?._id ||
          el.name === myName
        )

        let msObj

        if (myScore) {
          msObj = {
            key: scorr.length,
            id: myScore.id,
            name: myScore.name || myName,
            createdAt: myScore.createdAt,
            time: myScore.time,
            total: myScore.total,
            rank: myScore.rank,
          }
          Alldata.helper.leaderboard.active.map(active => {
            msObj[active] = myScore[active] ?? 0
          })
          scorr.splice(0, 0, msObj)
        } else {
          msObj = {
            key: scorr.length,
            id: myEmail,
            name: myName,
            createdAt: Date.now(),
            total: 0,
            time: 0,
            rank: scorr.length + 1,
          }
          Alldata.helper.leaderboard.active.map(active => {
            msObj[active] = 0
          })
          scorr.splice(0, 0, msObj)
        }

        setIndividualScore(scorr)

        // ── Trigger notification after data is ready ──────────
        setMyScoreObj(msObj)
        setShowNotif(true)
      })
  }, [])

  let columns = [
    { dataField: "rank",  text: "Rank",  sort: false },
    { dataField: "name",  text: "Name",  sort: false },
  ]
  Alldata.helper.leaderboard.active.map(active =>
    columns.push({ dataField: active, text: active, sort: false })
  )

  const pageOptions = { sizePerPage: 200, totalSize: IndividualScore.length, custom: true }
  const { SearchBar } = Search
  const tableClasses = "table align-middle table-nowrap lb-table"

  return (
    <React.Fragment>
      <div className="lb-page-content">
        {/* <div className="lb-grid" /> */}
        {/* <div className="lb-orb lb-orb-1" />
        <div className="lb-orb lb-orb-2" />
        <div className="lb-orb lb-orb-3" /> */}
        <div className="inv-bg-grid"              aria-hidden="true" />
        <div className="inv-bg-scanlines"         aria-hidden="true" />
        <div className="inv-shoot"                aria-hidden="true">
          <span/><span/><span/><span/><span/>
          <span/><span/><span/><span/>
          <i/><b/><em/>
        </div>

        <div className="container-fluid lb-container">
          {/* <div className="prof-header">
            <h1 className="prof-title">Leaderboard</h1>
          </div> */}
          {/* Header */}
        <header className="inv-header">
          <div className="inv-header-line inv-header-line--gold" />
          <h1 className="inv-header-title">
            <span className="inv-header-bracket">[</span>
            LEADERBOARD
            <span className="inv-header-bracket">]</span>
          </h1>
          <div className="inv-header-line inv-header-line--gold" />
        </header>

          <TabContent activeTab={activeTabContent} className="lb-tab-content">
            <TabPane tabId="1">
              <Row className="lb-row">
                <Col className="col-12 lb-col">
                  <Card className="lb-card">
                    <CardBody className="lb-card-body">
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="key" columns={columns} data={IndividualScore}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="key" columns={columns} data={IndividualScore} search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row className="mb-2">
                                  <Col xs="12">
                                    <div className="lb-search-wrap">
                                      <div className="position-relative">
                                        <SearchBar
                                          {...toolkitProps.searchProps}
                                          placeholder="Search name..."
                                        />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        keyField="key"
                                        responsive
                                        bordered={false}
                                        striped={false}
                                        classes={tableClasses}
                                        headerWrapperClasses="thead-light"
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="text-md-right ms-auto" hidden>
                                      <PaginationListStandalone {...paginationProps} />
                                    </div>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>

            <TabPane tabId="2">
              <Row className="lb-row">
                <Col className="col-12 lb-col">
                  <Card className="lb-card">
                    <CardBody className="lb-card-body">
                      <CardTitle className="lb-card-title">Team Leaderboard</CardTitle>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="key" columns={columns} data={TeamScore}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="key" columns={columns} data={TeamScore} search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row className="mb-2">
                                  <Col xs="12">
                                    <div className="lb-search-wrap">
                                      <div className="position-relative">
                                        <SearchBar {...toolkitProps.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        keyField="key" responsive bordered={false} striped={false}
                                        classes={tableClasses}
                                        headerWrapperClasses="thead-light"
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="text-md-right ms-auto">
                                      <PaginationListStandalone {...paginationProps} />
                                    </div>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>

      {/* ── Golden Level-Up Notification ── */}
      {!notifDone && (
        <LevelUpNotification
          myScore={myScoreObj}
          show={showNotif}
          onClose={() => {
            setShowNotif(false)
            setNotifDone(true)
          }}
        />
      )}

    </React.Fragment>
  )
}

export default Leaderboard